import { H4, P1, Rating } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations';
import React from 'react';
import styles from './Review.module.scss';

export type ReviewProps = {
  reviewNumber: number;
};

export const Review = (props: ReviewProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.review}>
      <H4 className={styles.reviewName}>{t(`reviews.name-${props.reviewNumber}`)}</H4>
      <div className={styles.reviewParagraph}>
        <Rating rating={parseInt(t(`reviews.rate-${props.reviewNumber}`))} ratingLabel={''} />
        <P1 className={styles.reviewText}>{t(`reviews.text-${props.reviewNumber}`)}</P1>
      </div>
    </div>
  );
};
